import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-147b33da")
const _hoisted_1 = { class: "not-found-room" }
const _hoisted_2 = { class: "not-found-room-msg" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "ルーム情報が取得できませんでした。", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "このルームは有効期限が切れているか、削除された可能性があります。", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("TOPに戻る")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_menu = _resolveComponent("header-menu")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_header_menu, {
      showHeaderMenu: false,
      title: "ルームタイトルが取得できませんでした"
    }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("p", null, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ])
  ]))
}